import { CmsApplianceDetailsForm } from '../../appliance-details-stepped/cms/cms-appliance-details.interface';
import { CmsArticleSearchForm } from '../../article-search/cms/cms-article-search-form.interface';
import { CmsSelfFixRoot } from '../../cms/cms-self-fix-root.interface';

export interface CmsApplianceDetailsPage
  extends CmsSelfFixRoot, CmsApplianceDetailsForm, CmsArticleSearchForm {}
